import { render, staticRenderFns } from "./changeLogView.vue?vue&type=template&id=4a56ffaa&scoped=true&"
import script from "./changeLogView.vue?vue&type=script&lang=js&"
export * from "./changeLogView.vue?vue&type=script&lang=js&"
import style0 from "./changeLogView.vue?vue&type=style&index=0&id=4a56ffaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a56ffaa",
  null
  
)

export default component.exports